import { apiAxiosAuth, apiAxiosCMS } from 'services/api';
import { RespRefreshTokenProps } from 'types/RespRefreshTokenProps';
import { TokensResp } from 'types/TokensResp';
import { ImgSavedProps } from 'types/ImgSavedProps';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { TypeStore } from 'types/TypeStoreProps';
import { UserProps } from 'types/UserProps';
import { RolesTypes } from 'types/RolesTypes';

// caso não seja passado textApi é passado como default a api de homolog
export function handleWithTypeStore(
	setTypeStore: React.Dispatch<React.SetStateAction<TypeStore>>
) {
	const url = window.location.href;

	//posso alterar esse tipo de acordo com a necessidade em ambiente de desenvolvimento
	if (url.includes('localhost')) {
		setTypeStore('default');
		return;
	}

	// ================= daqui pra baixo colocarei os nomes das lojas existentes =================
	if (url.includes('aguadecoco')) {
		setTypeStore('fashion');
		return;
	}

	if (url.includes('amobeleza')) {
		setTypeStore('fashion');
		return;
	}

	if (url.includes('superxtra')) {
		setTypeStore('grocery');
		return;
	}

	if (url.includes('drogasmill')) {
		setTypeStore('default');
		return;
	}

	//se não encontrar nada, o tipo da loja fica como default
	setTypeStore('default');
	return;
}

export const saveObjOnLocalStorage = (obj: object, local: string) => {
	localStorage.setItem(local, JSON.stringify(obj));
};

// caso não for passado nenhum local, irei pegar os dados do usuário que é o mais usado
export const getObjOnLocalStorage = (local = 'userDataMondelez') => {
	const valueLocalStorage = localStorage.getItem(local);
	if (!valueLocalStorage) return null;
	return JSON.parse(valueLocalStorage);
};

export const deleteEpecificObjOnLocalStorage = (local: string) => {
	localStorage.removeItem(local);
};

export const deleteAllLocalStorageLogout = () => {
	localStorage.clear();
};

export const logoutSystem = () => {
	deleteEpecificObjOnLocalStorage('tokensMondelez');
	deleteEpecificObjOnLocalStorage('userDataMondelez');
	window.location.href = '/';
};

// se o valor retorando for undefined, quer dizer que não foi encontrado o valor dentro da array passada
export function searchValueInArray(
	valueToSearch: string | number,
	array: any[]
) {
	if (typeof array === 'undefined') {
		return undefined;
	}
	const found = array.find((element) => element === valueToSearch);
	return found;
}

interface RespSaveImageOnServerProps {
	isSuccess: boolean;
	photo: null | ImgSavedProps;
}
export async function saveImageOnServer(
	imageOriginal: File, // Certifique-se de que este é um arquivo válido
	t: any,
	handleNotify: any,
	nameKeyOb = 'file'
) {
	const resp: RespSaveImageOnServerProps = { isSuccess: false, photo: null };

	// Criar um FormData e adicionar a imagem
	const formData = new FormData();
	formData.append(nameKeyOb, imageOriginal); // Verifique se o nome do campo esperado pelo backend é 'file'

	await apiAxiosCMS
		.post('upload', formData, {
			headers: {
				'Content-Type': 'multipart/form-data' // Define corretamente o tipo de conteúdo
			}
		})
		.then((res) => {
			resp.isSuccess = true;
			resp.photo = res.data;
			handleNotify(t('Foto salva com sucesso!'), 'success');
		})
		.catch((error) => {
			resp.isSuccess = false; // Aqui estava setando como true no catch, corrigido para false
			resp.photo = null;
			handleNotify(error?.message || t('Erro ao salvar a foto!'), 'error');
		});

	if (resp.isSuccess) {
		await apiAxiosCMS
			.get(`upload/${resp.photo?.id}`, {
				headers: {
					'Content-Type': 'multipart/form-data' // Define corretamente o tipo de conteúdo
				}
			})
			.then((res) => {
				resp.photo = res.data;
			});
	}

	return resp;
}

export async function deleteImageOnServer(
	idImg: string,
	handleNotify: any,
	t: any
) {
	const resp = { isSuccess: false };

	await apiAxiosCMS
		.delete(`upload/${idImg}`)
		.then(() => {
			resp.isSuccess = true;
			handleNotify(t('Foto deletada com sucesso!'), 'success');
		})
		.catch((error) => {
			resp.isSuccess = false; // Aqui estava setando como true no catch, corrigido para false
			handleNotify(error?.message || t('Erro ao deletar a foto!'), 'error');
		});

	return resp;
}
export function generateUid() {
	let u = '',
		i = 0,
		rb = (Math.random() * 0xffffffff) | 0;
	const m = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	while (i++ < 36) {
		const r = rb & 0xf;
		const c = m[i - 1],
			v = c === 'x' ? r : (r & 0x3) | 0x8;
		u += c === '-' || c === '4' ? c : v.toString(16);
		rb = i % 8 === 0 ? (Math.random() * 0xffffffff) | 0 : rb >> 4;
	}
	return u;
}

// passe o hexideximal como string
export function hexToRgb(hex: string) {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result
		? {
				R: parseInt(result[1], 16),
				G: parseInt(result[2], 16),
				B: parseInt(result[3], 16),
				A: 1
			}
		: { R: 0, G: 0, B: 0, A: 1 };
}

export async function refreshToken(
	userId: string,
	tokens: TokensResp,
	setIsOpenLoad: any,
	setColor: any,
	setMessage: React.Dispatch<React.SetStateAction<string>>,
	t: any
) {
	const resp: RespRefreshTokenProps = { isSuccess: false, tokens: null };
	const payload = {
		refresh_token: tokens?.refresh_token || '0'
	};

	setColor('white');
	setMessage(t('tokenValidate'));
	setIsOpenLoad(true);

	await apiAxiosAuth
		.post('auth/refresh', payload)
		.then((res) => {
			if (res?.data?.access_token && res?.data?.refresh_token) {
				resp.isSuccess = true;
				resp.tokens = {
					access_token: res.data.access_token,
					refresh_token: res.data.refresh_token
				};
			}
		})
		.catch(() => {
			resp.isSuccess = false;
			resp.tokens = null;
		});

	setIsOpenLoad(false);

	return resp;
}

export function verifyTimePassed(lastLogin: string): boolean {
	const lastLoginDate = new Date(lastLogin);
	const now = new Date();

	// Diferença em milissegundos
	const diffInMs = now.getTime() - lastLoginDate.getTime();

	// 1 hora em milissegundos (60 min * 60 seg * 1000 ms)
	// 30 minutos em milissegundos (30 min * 60 seg * 1000 ms)
	const oneHourInMs = 1 * 60 * 1000;

	return diffInMs >= oneHourInMs;
}

export function isValidCPF(cpf: string): boolean {
	cpf = cpf.replace(/[^\d]/g, ''); // Remove caracteres não numéricos

	if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
		return false; // Verifica se tem 11 dígitos e não são todos iguais
	}

	const calculateDigit = (slice: string, factor: number): number => {
		let total = 0;
		for (const num of slice) {
			total += parseInt(num) * factor--;
		}
		const remainder = total % 11;
		return remainder < 2 ? 0 : 11 - remainder;
	};

	const firstDigit = calculateDigit(cpf.slice(0, 9), 10);
	const secondDigit = calculateDigit(cpf.slice(0, 10), 11);

	return firstDigit === parseInt(cpf[9]) && secondDigit === parseInt(cpf[10]);
}

export function isValidEmail(email: string): boolean {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test(email);
}

// minimo 8 caracteres e Incluir Letras Maiúsculas
// Incluir Letras Minúsculas
// Incluir Números
// Incluir Caracteres Especiais
// (!@#$%&*()-+.,;?{[}]^><:)
export function isValidPassword(password: string): boolean {
	const minLength = 8;
	const hasLowerCase = /[a-z]/.test(password);
	const hasUpperCase = /[A-Z]/.test(password);
	const hasNumber = /\d/.test(password);
	const hasSpecialChar = /[\W_]/.test(password);

	return (
		password.length >= minLength &&
		hasLowerCase &&
		hasUpperCase &&
		hasNumber &&
		hasSpecialChar
	);
}

//pase o nome do item e não o id
export function returnElementToSelectComponentByName(
	list: SelectInputItemProps[],
	itemToFound: string
) {
	if (list.length > 0 && itemToFound) {
		const itemFound = list.filter((item) => item.option === itemToFound);

		if (itemFound.length > 0) {
			return itemFound[0];
		} else {
			return null;
		}
	}

	return null;
}

//retorna as roles do usuário em uma string para leitura
export function returnRoles(roles: string[]) {
	let text = '';

	if (roles && roles.length > 0) {
		roles.forEach((item) => {
			if (text === '') {
				text = `${item}`;
			} else {
				text = `${text} | ${item}`;
			}
		});
	}

	return text === '' ? 'users.listUsers.noTypeRegistered' : text;
}

//retorna o cpf formatado 862.381.480-04
export function formatCPF(cpf: string): string {
	return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
}

// recebe data assim "2025-03-21T14:49" e retorna assim "2025-03-21T14:49:00.000Z"
export function formatDateToISO(dateStr: string) {
	const date = new Date(dateStr);
	if (isNaN(date.getTime())) return '';
	return date.toISOString();
}

// recebe data assim "2025-03-21T14:49:00.000Z" e retorna assim  "2025-03-21T14:49"
export function formatToDateCustom(isoStr: string) {
	if (isoStr === '') {
		return '';
	}

	const date = new Date(isoStr);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	return `${year}-${month}-${day}T${hours}:${minutes}`;
}

// recebe data assim "2025-03-21T14:49:00.000Z" e retorna assim "21/03/2025"
// com horário: "21/03/2025 11:49" (por exemplo, se offset for -3)
export function formatDateToView(
	dateStr: string,
	withTime: boolean = false,
	offsetHours: number = 0
): string {
	try {
		const date = new Date(dateStr);

		if (isNaN(date.getTime())) throw new Error('Invalid date');

		// aplica o offset manual em milissegundos
		const offsetDate = new Date(date.getTime() + offsetHours * 60 * 60 * 1000);

		const day = String(offsetDate.getUTCDate()).padStart(2, '0');
		const month = String(offsetDate.getUTCMonth() + 1).padStart(2, '0');
		const year = offsetDate.getUTCFullYear();

		let formattedDate = `${day}/${month}/${year}`;

		if (withTime) {
			const hours = String(offsetDate.getUTCHours()).padStart(2, '0');
			const minutes = String(offsetDate.getUTCMinutes()).padStart(2, '0');
			formattedDate += ` ${hours}:${minutes}`;
		}

		return formattedDate;
	} catch {
		return '01/01/2001';
	}
}

//retorna as dimensões de uma imagem pela url
//Usar desta forma:
//  getImageDimensions(listBanners[0].image.relativePath)
// .then((size) => {
//		console.log('✌️size --->', size);
// })
// .catch((error) => {
//		console.log('✌️error --->', error);
// });
export function getImageDimensions(
	url: string
): Promise<{ width: number; height: number }> {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.src = url;
		img.onload = () =>
			resolve({ width: img.naturalWidth, height: img.naturalHeight });
		img.onerror = (error) => reject(error);
	});
}

export function shrinkText(text: string, qtdCute = 50) {
	if (typeof text === 'string') {
		const textLength = text.length;
		if (textLength <= qtdCute) {
			return text;
		} else {
			return `${text.slice(0, qtdCute)}...`;
		}
	}
	return text;
}

//formata um number para o valor em dinheiro ex: 20.5 para R$50,50
export function formatCurrency(
	value: number,
	currencySymbol: string = 'R$'
): string {
	return `${currencySymbol} ${value.toLocaleString('pt-BR', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	})}`;
}

//Se for passar um numero, passe como string ou number mas pelo menos passe o numero sendo string ou number
export function formatClick(value: any) {
	if (value === undefined || value === null || value === '') {
		return 0;
	}

	if (typeof value === 'string') {
		const newValue = parseInt(value);
		return newValue.toLocaleString('pt-BR', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		});
	}

	if (typeof value === 'number') {
		return value.toLocaleString('pt-BR', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		});
	}

	return 0;
}

//busca opção dos inputs de select
export function findOptionOnListById(
	value: string,
	list: SelectInputItemProps[]
) {
	const itemsList = list.filter((item) => item.id === value);
	if (itemsList.length > 0) {
		return itemsList[0];
	}

	return '';
}

export async function getRoles(
	setIsSearchingRoles: React.Dispatch<React.SetStateAction<boolean>>,
	setListRoles: React.Dispatch<React.SetStateAction<RolesTypes[]>>,
	handleNotify: any
) {
	const dataUser: null | UserProps = getObjOnLocalStorage();
	const tokens: null | TokensResp = getObjOnLocalStorage('tokensMondelez');

	if (dataUser !== null && tokens !== null) {
		setIsSearchingRoles(true);
		await apiAxiosAuth
			.get('permissions/roles')
			.then((resp) => {
				if (resp.data && resp.data.length > 0) {
					setListRoles(resp.data);
				}
				setIsSearchingRoles(false);
			})
			.catch((error) => {
				setIsSearchingRoles(false);
				handleNotify(
					error?.response?.data?.message ||
						'Erro ao buscar as roles do usuário',
					'error'
				);
			});
	}
}

// recebe data assim 2025-08-29 e retorna assim sexta-feira, 10 de janeiro de 2025
export function formatDateBR(dateString: string): string {
	const date = new Date(dateString + 'T00:00:00');

	// verificar se a data é válida
	if (isNaN(date.getTime())) {
		return 'Data inválida';
	}

	const options: Intl.DateTimeFormatOptions = {
		weekday: 'long', // nome do dia da semana
		day: '2-digit', // dia do mês
		month: 'long', // nome do mês
		year: 'numeric' // ano completo
	};

	return new Intl.DateTimeFormat('pt-BR', options).format(date);
}

export function canAcessAdminPanel(roles: string[]): boolean {
	if (roles.includes('sysadmin') || roles.includes('corebiz')) {
		return true;
	}
	return false;
}

export function removeSpecialCharacters(input: string): string {
	return input.replace(/[^a-zA-Z0-9]/g, '');
}
